import { render } from "./lisvViewMessageTemplate.vue?vue&type=template&id=42765373"
import script from "./lisvViewMessageTemplate.vue?vue&type=script&lang=js"
export * from "./lisvViewMessageTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__